// extracted by mini-css-extract-plugin
export default {"tableContainer":"RequestedToken_tableContainer__aPAdx"};